//jshint ignore:start
(function() {
    'use strict';

    function imClosePopup($rootScope) {
        function link(scope, element, attrs) {
            element.on('click', function(event) {
                $rootScope.$broadcast('imHidePopup');
            });
        }
        return {
            link: link,
            scope: {
                active: '='
            }
        };
    }

    /**
     * Útil para eventos génericos sin dimensiones extra
     */
    function imGenericEvent(imEventService) {
        function link(scope, element, attrs) {
            element.on('mousedown', function(e) {
                if (e.which === 1 || e.which === 2) {
                    var eventData = {
                        eventData: {
                            cf: scope.cf,
                            category: scope.category,
                            action: scope.action,
                            label: scope.label
                        }
                    };
                    imEventService.analyticsEvent([eventData]);
                }
            });
        }
        return {
            link: link,
            scope: {
                cf: '@',
                category: '@',
                action: '@',
                label: '@',
            },
            priority: 10
        };
    }

    /**
     * imAccessEvent directive eventos de perfil usuario
     */
    function imAccessEvent(imAccessService) {
        function link(scope, element, attrs) {
            element.on('mousedown', function(e) {
                if (e.which === 1 || e.which === 2) {
                    imAccessService.createEvent(scope.category, scope.action, scope.label);
                }
            });
        }
        return {
            link: link,
            scope: {
                category: '@',
                action: '@',
                label: '@',
            },
            priority: 10
        };
    }


    /**
     *  Para emitir el evento de seleccionar tienda_favorita en mobile|tablet mediante directiva
     */
    function imFavouriteShipping(imShippingService) {
        function link(scope, element, attrs) {
            element.on('mousedown', function(e) {
                if (e.which === 1 || e.which === 2) {
                    imShippingService.selectedFavorite(scope.store);
                }
            });
        }
        return {
            link: link,
            scope: {
                store: '=',
            },
            priority: 10
        };
    }

    /**
     * Útil para eventos génericos que se lanzan despúes de comprobar que los formularios están validados
     */
    function imGenericFormEvent(imEventService) {
        function link(scope, element, attrs) {
            element.on('click', function() {
                if (scope.valid === 'true') {
                    var eventData = {
                        eventData: {
                            cf: scope.cf,
                            category: scope.category,
                            action: scope.action,
                            label: scope.label
                        }
                    };
                    imEventService.analyticsEvent([eventData]);
                }
            });
        }
        return {
            link: link,
            scope: {
                cf: '@',
                category: '@',
                action: '@',
                label: '@',
                valid: '@'

            },
            priority: 10
        };
    }
    /**
     * IMAnalytics Vista Guia etiquetado
     */
    function imGenericPage(imEventService, imTrackingCommonService) {
        function link(scope, element, attrs) {
                var page  = imTrackingCommonService.pageContext(scope.section, scope.pageType, scope.pageTitle);
                imEventService.pageView([page]);
        }
        return {
            link: link,
            scope: {
                section: '@',
                pageType: '@',
                pageTitle: '@'
            }
        };
    }

    angular.module('imAnalytics')
        .directive('imClosePopup', ['$rootScope', 'imTrackingCommonService', imClosePopup])
        .directive('imGenericFormEvent', ['imEventService', imGenericFormEvent])
        .directive('imGenericPage', ['imEventService', 'imTrackingCommonService', imGenericPage])
        .directive('imAccessEvent', ['imAccessService', imAccessEvent])
        .directive('imFavouriteShipping', ['imShippingService', imFavouriteShipping])
        .directive('imGenericEvent', ['imEventService', 'imTrackingCommonService', imGenericEvent]);
})();
